import { render, staticRenderFns } from "./ImportPhotoMobile.vue?vue&type=template&id=3ac966a4&scoped=true"
import script from "./ImportPhotoMobile.vue?vue&type=script&lang=js"
export * from "./ImportPhotoMobile.vue?vue&type=script&lang=js"
import style0 from "./ImportPhotoMobile.vue?vue&type=style&index=0&id=3ac966a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ac966a4",
  null
  
)

export default component.exports